import React from "react";
import "./css/ReviewStep.css";
import { serverHost } from "variables/serverdata";

const WizardFinish = ({ navigate, formData, site_uuid }) => {
  const clientId = localStorage.getItem("clientId");
  const fetchSite = async () => {
    console.log("Navigating to new page");
      const token =
        JSON.parse(localStorage.getItem("user") || "{}")?.access_token ||
        localStorage.getItem("token");

      // 1. Fetch client sites
      const client_resp = await fetch(`${serverHost}/fetch_client_sites`, {
        method: "GET",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          client: clientId,
        },
      });
      const json = await client_resp.json();

      if (!client_resp.ok) {  
        console.error("Site Wizard Nav - fetchSites failed:", json);
        return;
      }

      const rows = json.data || [];
      const sitesArr = rows.map((s) => ({
        ...s,
        site_name: s.site_name || s.company_name,
      }));

      // 2. Find the target site from the list
      const targetSite = sitesArr.find((s) => s.site_uuid === site_uuid) || sitesArr[0];
      console.log(targetSite);
      if (!targetSite) {
        console.error("Site Wizard Nav - no matching site found");
        return;
      }

      // 3. Store everything in localStorage
      localStorage.setItem("clientSites", JSON.stringify(sitesArr));
      localStorage.setItem("selectedSite", JSON.stringify(targetSite));
      window.dispatchEvent(new CustomEvent("siteChanged", {detail: targetSite}))
  };

  const hrmsNavigation = () => {};

  const didsNavigation = () => {
    fetchSite()
    navigate("/admin/hucs/import-did")
  };

  const newSiteNavigation = async () => {
    try {
      fetchSite()
      navigate("/admin/home"); 

    } catch (err) {
      console.error("Failed to get site information!", err);
    }
  };

  const sitesNavigation = () => {
    navigate("/admin/companysites");
  };
  return (
    <div className="review-container">
      <div className="review-panel review-panel-left" style={{ flex: 1 }}>
        <h6 className="review-panel-title">Next Steps</h6>
        <p style={{ marginBottom: "1rem" }}>
          Your site has been successfully created!
        </p>
        <p style={{ marginBottom: "0.5rem" }}>From here, you can:</p>
        <ul style={{ paddingLeft: "1.25rem", marginBottom: "1.5rem" }}>
          <li style={{ marginBottom: "0.4rem" }}>
            <span>Import a DID</span>
          </li>
          {formData.domain_detail.modules?.includes("HRMS") && (
            <li>
              <span>Create a new HRMS proxy</span>
            </li>
          )}
        </ul>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          <span style={{ color: "var(--color-text-secondary, #666)" }}>
            Or —
          </span>
          <span onClick={newSiteNavigation}>Go to new site</span>
          <span style={{ color: "var(--color-text-secondary, #666)" }}>|</span>
          <span onClick={sitesNavigation}>Return to sites list</span>
        </div>
      </div>
    </div>
  );
};

export default WizardFinish;
